<div class="row justify-content-center mt-4 mb-5">
  <div class="col-12 col-md-10 col-lg-7">
    <div class="card">
      <div class="card-body p-4 p-md-5">

        <ng-container *ngIf="submittedInvoiceNumber === null; else confirmation">
          <h1 class="page-title noselect">Vehicle Drop-Off</h1>
          <p class="page-subtitle noselect">
            Dropping off your vehicle? Tell us how to reach you and what's going
            on, and a mechanic will look it over and follow up with a quote.
          </p>

          <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <div class="form-section">
            <h3 class="section-title noselect">Your Information</h3>
            <div class="form-row">
              <div class="form-group">
                <app-input
                  [form]="contactForm"
                  formGroupName="firstName"
                  placeHolder="First Name"
                ></app-input>
              </div>
              <div class="form-group">
                <app-input
                  [form]="contactForm"
                  formGroupName="lastName"
                  placeHolder="Last Name"
                ></app-input>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group">
                <app-input
                  [form]="contactForm"
                  formGroupName="phone"
                  placeHolder="Phone Number"
                  inputType="tel"
                ></app-input>
              </div>
              <div class="form-group">
                <app-input
                  [form]="contactForm"
                  formGroupName="email"
                  placeHolder="Email (optional)"
                  inputType="email"
                ></app-input>
              </div>
            </div>
            <div *ngIf="hasEmail" class="email-notifications noselect">
              <span class="form-label me-3">Email me updates about my vehicle?</span>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="emailNotificationsYes"
                       formControlName="emailNotifications" value="yes">
                <label class="form-check-label" for="emailNotificationsYes">Yes</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" id="emailNotificationsNo"
                       formControlName="emailNotifications" value="no">
                <label class="form-check-label" for="emailNotificationsNo">No</label>
              </div>
            </div>
            <div class="create-account noselect">
              <div class="form-check">
                <input class="form-check-input" type="checkbox" id="createAccountCheck"
                       formControlName="createAccount">
                <label class="form-check-label" for="createAccountCheck">
                  Create an account so I can log in and track my vehicle (requires email)
                </label>
              </div>
            </div>
            <div *ngIf="wantsAccount" class="form-row">
              <div class="form-group">
                <app-input
                  [form]="contactForm"
                  formGroupName="password"
                  placeHolder="Password"
                  inputType="password"
                  [passwordHelpEnabled]="true"
                ></app-input>
              </div>
              <div class="form-group">
                <app-input
                  [form]="contactForm"
                  formGroupName="confirmPassword"
                  placeHolder="Confirm Password"
                  inputType="password"
                ></app-input>
              </div>
            </div>
          </div>

          <div class="form-section">
            <h3 class="section-title noselect">Vehicle Information</h3>
            <app-vehicle-form-fields [form]="vehicleForm"></app-vehicle-form-fields>
          </div>

          <div class="form-section">
            <h3 class="section-title noselect">What's Going On?</h3>
            <div class="form-group">
              <textarea
                class="message-input"
                formControlName="issueDescription"
                placeholder="Describe the issue or the service you need (e.g. brakes squealing, oil change, check engine light)"
                rows="4"
                maxlength="1000"
              ></textarea>
              <div *ngIf="contactForm.get('issueDescription')?.touched && contactForm.get('issueDescription')?.invalid" class="field-error noselect">
                Please tell us why you're dropping off your vehicle.
              </div>
            </div>
          </div>

          <div class="form-actions noselect">
            <button type="submit" class="btn btn-primary" [disabled]="isSubmitting">
              <span *ngIf="!isSubmitting">Check In Vehicle</span>
              <span *ngIf="isSubmitting">
                <span class="spinner-small"></span> Checking In...
              </span>
            </button>
          </div>
          </form>
        </ng-container>

        <ng-template #confirmation>
          <div class="confirmation noselect">
            <div class="confirmation-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <h1 class="page-title">You're Checked In!</h1>
            <p class="confirmation-reference">Reference #{{ submittedInvoiceNumber }}</p>
            <p *ngIf="accountAlreadyExists" class="account-exists-note">
              An account already exists for this contact info &mdash; use Forgot
              Password on the login page to sign in.
            </p>
            <p class="page-subtitle">
              Please leave your keys at the desginated drop point. A mechanic will review
              your vehicle and reach out with a quote.
            </p>
            <button type="button" class="btn btn-secondary" (click)="checkInAnotherVehicle()">
              Check In Another Vehicle
            </button>
          </div>
        </ng-template>

      </div>
    </div>
  </div>
</div>
